import "./App.css";
import Routes from "./Routes/Routes";
import "./App.css";
export default function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}
